import { render, staticRenderFns } from "./MisSolicitudes.vue?vue&type=template&id=2a7d85fb&scoped=true&"
import script from "./MisSolicitudes.vue?vue&type=script&lang=ts&"
export * from "./MisSolicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./MisSolicitudes.vue?vue&type=style&index=0&id=2a7d85fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d85fb",
  null
  
)

export default component.exports